/* Tildas redesign mega-menu: opens on hover (desktop pointer) and on click/Enter,
   closes on Escape, outside click, or leaving the header. One panel open at a time. */
(() => {
  const root = document.querySelector('[data-tb-mega]');
  if (!root) return;
  const header = root.closest('.tb-header') || root;
  const triggers = [...root.querySelectorAll('[data-tb-mega-trigger]')];
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  let openTimer;

  const panelOf = (btn) => document.getElementById(btn.getAttribute('aria-controls'));
  const close = (btn) => {
    btn.setAttribute('aria-expanded', 'false');
    const p = panelOf(btn);
    if (p) p.hidden = true;
  };
  const closeAll = (except) => triggers.forEach((b) => b !== except && close(b));
  const open = (btn) => {
    closeAll(btn);
    btn.setAttribute('aria-expanded', 'true');
    const p = panelOf(btn);
    if (p) p.hidden = false;
  };

  triggers.forEach((btn) => {
    btn.addEventListener('click', () => (btn.getAttribute('aria-expanded') === 'true' ? close(btn) : open(btn)));
    btn.addEventListener('mouseenter', () => {
      if (!canHover.matches) return;
      clearTimeout(openTimer);
      openTimer = setTimeout(() => open(btn), 80);
    });
  });

  header.addEventListener('mouseleave', () => {
    if (!canHover.matches) return;
    clearTimeout(openTimer);
    closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openBtn = triggers.find((b) => b.getAttribute('aria-expanded') === 'true');
    if (openBtn) {
      close(openBtn);
      openBtn.focus();
    }
  });

  document.addEventListener('click', (e) => {
    if (!root.contains(e.target)) closeAll();
  });
})();

/* "Om Tildas" dropdown: a <details>; opens on hover with a fine pointer, closes on outside click,
   Escape, or when the mega-menu opens. */
(() => {
  const about = document.querySelector('[data-tb-about]');
  if (!about) return;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  let closeTimer;
  about.addEventListener('mouseenter', () => { if (!canHover.matches) return; clearTimeout(closeTimer); about.open = true; });
  about.addEventListener('mouseleave', () => { if (!canHover.matches) return; closeTimer = setTimeout(() => { about.open = false; }, 200); });
  document.addEventListener('click', (e) => { if (!about.contains(e.target)) about.open = false; });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && about.open) { about.open = false; about.querySelector('summary').focus(); }
  });
  document.querySelectorAll('[data-tb-mega-trigger]').forEach((b) => b.addEventListener('mouseenter', () => { about.open = false; }));
})();

/* Phone/iPad: the header (bar + chips) sticks to the top, slides away while scrolling down and comes
   back on the first scroll up, so the menu and cart are always one flick away. */
(() => {
  const header = document.querySelector('.tb-header');
  const section = header && header.closest('.shopify-section');
  if (!section) return;
  section.classList.add('tb-sticky');
  const small = window.matchMedia('(max-width: 1023px)');
  let lastY = window.scrollY;
  let ticking = false;
  const update = () => {
    ticking = false;
    const y = window.scrollY;
    const drawerOpen = document.querySelector('header-drawer details[open], .menu-drawer-container[open]');
    if (!small.matches || drawerOpen || y < section.offsetHeight) section.classList.remove('tb-sticky--hidden');
    else if (y > lastY + 4) section.classList.add('tb-sticky--hidden');
    else if (y < lastY - 4) section.classList.remove('tb-sticky--hidden');
    lastY = y;
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
})();

/* Scrollbar width as --tb-sbw for the scroll lock in tb-header.css (measured only while the page is not locked). */
(() => {
  const root = document.documentElement;
  const measure = () => {
    if (document.body && document.body.classList.contains('overflow-hidden')) return;
    root.style.setProperty('--tb-sbw', (window.innerWidth - root.clientWidth) + 'px');
  };
  measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);
})();


/* Live order count: every "1 500+" / "Över 1 500" claim (announcement bar, trust strips, reviews line,
   product page promises) shows the shop's real number of orders from the Worker (/order-count, refreshed
   hourly), rounded down to ten and written the local way (2 140 / 2,140 / 2.140). The typed text stays
   when the Worker does not answer, and is only replaced by a higher number, never a lower one. */
(function () {
  var API = 'https://tildas-poster-api.tildas-birth-posters.workers.dev/order-count';
  var KEY = 'tb-order-count-v1';
  var BASE = 1500;
  // "1 500+", "1,500+", "1.500+", or after Över / Over / Über; not a price like "1 500 kr"
  var RE = /((?:Över|Over|Über|über|över)\s+)1[\s\u00a0\u202f.,]?500(?![\d])|1[\s\u00a0\u202f.,]?500\+/g;
  function apply(count) {
    if (!(count > BASE)) return;
    var n = Math.floor(count / 10) * 10;
    var lang = document.documentElement.lang || 'sv';
    var txt;
    try { txt = new Intl.NumberFormat(lang).format(n); } catch (e) { txt = String(n); }
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|INPUT)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        return /1[\s\u00a0\u202f.,]?500/.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      node.nodeValue = node.nodeValue.replace(RE, function (m, pre) { return pre ? pre + txt : txt + '+'; });
    });
  }
  function run() {
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (cached && cached.count) { apply(cached.count); return; }
    if (!window.fetch) return;
    fetch(API, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d || !d.count) return;
      try { sessionStorage.setItem(KEY, JSON.stringify({ count: d.count })); } catch (e) {}
      apply(d.count);
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
